export var KeyboardTypeToken;
(function (KeyboardTypeToken) {
    KeyboardTypeToken["default"] = "default";
    KeyboardTypeToken["numberPad"] = "number-pad";
    KeyboardTypeToken["decimalPad"] = "decimal-pad";
    KeyboardTypeToken["numeric"] = "numeric";
    KeyboardTypeToken["email"] = "email-address";
    KeyboardTypeToken["phone"] = "phone-pad";
    KeyboardTypeToken["url"] = "url";
})(KeyboardTypeToken || (KeyboardTypeToken = {}));
export var InputTypeToken;
(function (InputTypeToken) {
    InputTypeToken["MOBILE"] = "MOBILE";
    InputTypeToken["EMAIL"] = "EMAIL";
    InputTypeToken["OTP"] = "OTP";
    InputTypeToken["SEARCH"] = "SEARCH";
    InputTypeToken["MULTILINE"] = "MULTILINE";
    InputTypeToken["DEFAULT"] = "DEFAULT";
    // CALENDAR = 'CALENDAR',
})(InputTypeToken || (InputTypeToken = {}));
export var InputStateToken;
(function (InputStateToken) {
    InputStateToken["DEFAULT"] = "DEFAULT";
    InputStateToken["DISABLED"] = "DISABLED";
    InputStateToken["LOADING"] = "LOADING";
    InputStateToken["SUCCESS"] = "SUCCESS";
    InputStateToken["ERROR"] = "ERROR";
    InputStateToken["FOCUS"] = "FOCUS";
    InputStateToken["SELECTION"] = "SELECTION";
})(InputStateToken || (InputStateToken = {}));
export var TextInputTypeToken;
(function (TextInputTypeToken) {
    TextInputTypeToken["FULL"] = "FULL";
    TextInputTypeToken["CONTENT"] = "CONTENT";
})(TextInputTypeToken || (TextInputTypeToken = {}));
